(function () {
  function init(bar) {
    if (bar.dataset.bound) return;
    bar.dataset.bound = 'true';

    var targetId = bar.getAttribute('data-observe-target');
    var target = document.getElementById(targetId);
    if (!target) return;

    var footer = document.querySelector('footer.footer');

    var state = { pastButton: false, nearFooter: false };

    function updateVisibility() {
      var visible = state.pastButton && !state.nearFooter;
      bar.setAttribute('data-visible', visible ? 'true' : 'false');
    }

    var buttonObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          state.pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        });
        updateVisibility();
      },
      { threshold: 0 }
    );

    buttonObserver.observe(target);

    if (footer) {
      // Hide the bar before the footer (payment icons, policy links) reaches
      // the viewport, so the fixed bar never overlaps footer content.
      var footerObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            state.nearFooter = entry.isIntersecting;
          });
          updateVisibility();
        },
        { threshold: 0, rootMargin: '0px 0px 100px 0px' }
      );

      footerObserver.observe(footer);
    }
  }

  function initAll() {
    document.querySelectorAll('.sticky-buy-bar').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
